<template>
  <v-container fluid>
    <div v-if="sleuthConfig">
      <div class="text-h5 text-left">Bot Settings</div>
      <v-divider></v-divider>
      <div class="text-subtitle-2 mt-2 mb-2 text-left grey--text text--darken-1">
        Pick which features of the bot you want to use
      </div>
      <v-row>

        <v-col cols="12" sm="6" md="4" lg="3">
          <v-switch v-model="sleuthConfig.active" label="Active" hint="Enable the bot" persistent-hint></v-switch>
        </v-col>
        <v-col cols="12" sm="6" md="4" lg="3">
          <v-switch v-model="sleuthConfig.check_all_submissions" label="Post Checking" hint="Automatically check new posts" persistent-hint></v-switch>
        </v-col>
        <v-col cols="12" sm="6" md="4" lg="3">
          <v-switch v-model="sleuthConfig.comment_on_repost" label="Repost Comment" hint="Leave Comment on Reposts" persistent-hint></v-switch>
        </v-col>
        <v-col cols="12" sm="6" md="4" lg="3">
          <v-switch v-model="sleuthConfig.comment_on_oc" label="OC Comment" hint="Leave Comment on OC" persistent-hint></v-switch>
        </v-col>
        <v-col cols="12" sm="6" md="4" lg="3">
          <v-switch v-model="sleuthConfig.disable_bot_summons" label="No Summons" hint="Disallow bot summoning" persistent-hint></v-switch>
        </v-col>
        <v-col cols="12" sm="6" md="4" lg="3">
          <v-switch v-model="sleuthConfig.only_allow_one_summons" label="One Summons" hint="Only allow 1 summons" persistent-hint></v-switch>
        </v-col>
        <v-col cols="12" sm="6" md="4" lg="3">
          <v-switch v-model="sleuthConfig.remove_additional_summons" label="Delete Summons" hint="Delete additional summons" persistent-hint :disabled="!sleuthConfig.only_allow_one_summons"></v-switch>
        </v-col>
        <v-col cols="12" sm="6" md="4" lg="3">
          <v-switch v-model="sleuthConfig.report_reposts" label="Report Post" hint="Report Reposts" persistent-hint></v-switch>
        </v-col>
        <v-col cols="12">
          <v-slider
              v-model="sleuthConfig.target_image_match"
              thumb-label
              label="% Match"
              min="60"
              max="100"
              hint="How close a match should be"
              persistent-hint
          ></v-slider>
        </v-col>

      </v-row>
    </div>
  </v-container>
</template>

<script>
export default {
  name: "BotSettings",
  props: {
    sleuthConfig: Object
  }
}
</script>

<style scoped>

</style>
